/**
 * Route: /monthly-report — W2.2
 *
 * Monatlicher Reward-Report (FR29, FR30).
 * Period via URL-Search-Param (?period=YYYY-MM).
 * TanStack Router validiert und coerct automatisch.
 */
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { MonthlyReportPageRoute } from '../features/reports/MonthlyReportPage'

const monthlyReportSearchSchema = z.object({
  // FE-ROB-06: ?period=2026-1 (aus einer Mail o. ae.) faellt auf den Default
  // zurueck statt die komplette Seite durch die Fehlerseite zu ersetzen.
  period: z.string().regex(/^\d{4}-\d{2}$/).optional().catch(undefined),
})

export const Route = createFileRoute('/_auth/monthly-report')({
  validateSearch: monthlyReportSearchSchema,
  component: MonthlyReportRoute,
})

function MonthlyReportRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  function handleNavigate(opts: { search: (prev: Record<string, unknown>) => Record<string, unknown> }) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(navigate as any)(opts)
  }

  return (
    <MonthlyReportPageRoute
      period={search.period}
      navigate={handleNavigate}
    />
  )
}
